import React from 'react';
import PropTypes from 'prop-types';
import { FDIcon } from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { GoalWithoutThreshold } from 'Components/UI/guidedHouseholdReview/goalWithoutThreshold';

const useStyles = buildUseStyles('GuidedHouseholdReviewNonDraggableGoal', (theme) => ({
  stone600Icon: {
    '& > .FD-MuiSvgIcon-root': {
      color: theme.palette.facet.stone600,
    },
  },
}));

export const GuidedHouseholdReviewNonDraggableGoal = ({ stepResource }) => {
  const classes = useStyles();
  const prefix = (
    <div className={classes.stone600Icon}>
      <FDIcon
        icon="dragIndicator"
        size="md"
        color="textDisabled"
      />
    </div>
  );
  return <GoalWithoutThreshold resource={stepResource} prefix={prefix} />;
};

GuidedHouseholdReviewNonDraggableGoal.propTypes = {
  stepResource: PropTypes.object.isRequired,
};
